export default __webpack_public_path__ + "static/media/Avalara_Logo.75ed3c5f.png";